import { MaxLocationChangeEventDetail } from "../model/MaxLocationChangeEventDetail";
var isInitialised = false;
export var bindHistoryChangeEventListeners = function () {
    if (isInitialised)
        return;
    isInitialised = true;
    history.pushState = wrapWithCustomEventDispatch(history.pushState);
    history.replaceState = wrapWithCustomEventDispatch(history.replaceState);
    window.addEventListener("popstate", function (e) {
        dispatchMaxLocationChangeCustomEvent(document.location.href);
    });
};
var wrapWithCustomEventDispatch = function (originalFn) {
    return function fn(data, title, url) {
        dispatchMaxLocationChangeCustomEvent(url);
        return originalFn.apply(this, [data, title, url]);
    };
};
var dispatchMaxLocationChangeCustomEvent = function (target) {
    var targetUrl = !!target ? new URL(target, document.location.origin) : undefined;
    window.dispatchEvent(new CustomEvent("maxlocationchange", {
        detail: new MaxLocationChangeEventDetail(targetUrl)
    }));
};
